import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Constants from "../../constants";

const initialState = {
    questionData : [],
    teamId : '',
    personId : '',
    isLoading : false,
    messageType : '',
    messageCondition : false,
    message : '',
    languageOptions: [],
    guideContent: [],
    personalDetailsContent: [],
}

export const surveyCompletedValidatorServer = createAsyncThunk(
    'survey/surveyCompletedValidatorServer',
    async(params) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'CheckSubmissionDNAJSON?Token='+params.usertoken+'&PersonID='+params.personId+'&TeamID='+params.teamId+'&CategoryID='+(params.categoryId == '' ? '%' : params.categoryId)+'&SectionID='+(params.sectionId == '' ? '%' : params.sectionId)+'&SeqID='+(params.seqId == '' ? '%' : params.seqId)+'&Score='+(params.score == '' ? '%' : params.score), {
                method : 'GET'
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return err
        }
    }
)

export const surveyQuestionnaireServer = createAsyncThunk(
    'survey/surveyQuestionServer',
    async (params) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'QuestionnaireJSON?Token='+params.usertoken+'&QuestionType=DNA&Language='+params.language,{
                method : 'GET'
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return err
        }
    }
)

export const submitQuestionnaireServer = createAsyncThunk(
    'survey/submitQuestionnaireServer',
    async(params) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'SubmitAnswerDNAJSON?Token='+params.usertoken+'&TeamID='+params.teamId+'&PersonID='+params.personId+'&CategoryID='+params.categoryId+'&SectionID='+params.sectionId+'&SeqID='+params.seqId+'&Score='+params.score,{
                method : 'GET'
            })
            const data = await response.json();
            return data
        }
        catch(err){
            return err
        }
    }
)

export const NotifyTeamSubmissionJSON = createAsyncThunk(
    "Survey/NotifyTeamSubmissionJSON", async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'NotifyTeamSubmissionJSON?Token='+credentials.usertoken+'&TeamID='+credentials.teamId+'&PersonID='+credentials.personId+'&Language=ENG',{
                method: 'get'
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log("Notify team submission error",err)
        }
    }
)

const surveyQuestionSlice = createSlice({
    name : 'surveyQuestion',
    initialState,
    reducers: {
        setTeamId : (state, action) => {
            state.teamId = action.payload
        },
        setPersonId : (state, action) => {
            state.personId = action.payload
        },
        setSuccessMessage : (state, action) => {
            state.message = 'Completed successfully'
            state.messageCondition = true
            state.messageType = 'success'
        },
        setErrorMessage : (state, action) => {
            state.message = 'Survey incomplete'
            state.messageCondition = true
            state.messageType = 'error'
        },
        setMessageToFalse : (state, action) => {
            state.messageCondition = false
        }
    },
    extraReducers : {
        [surveyQuestionnaireServer.pending] : (state, action) => {

        },
        [surveyQuestionnaireServer.fulfilled] : (state, action) => {
            state.questionData = action.payload.Questionnaire.Question
            state.languageOptions = action.payload.Questionnaire.LanguageOption
            state.guideContent = action.payload.Questionnaire.Guide
            state.personalDetailsContent = action.payload.Questionnaire.Person
        },
        [surveyQuestionnaireServer.rejected] : (state, action) => {

        },
        [submitQuestionnaireServer.pending] : (state, action) => {
                state.message = ''
                state.messageCondition = false
                state.messageType = ''
        },
        [submitQuestionnaireServer.fulfilled] : (state, action) => {
            if(Object.keys(action.payload) == 'Error'){
                state.message = action.payload.Error
                state.messageCondition = true
                state.messageType = 'error'
            }
        },
        [submitQuestionnaireServer.rejected] : (state, action) => {

        },
        [surveyCompletedValidatorServer.pending] : (state, action) => {
                state.message = ''
                state.messageCondition = false
                state.messageType = ''
                state.isLoading = true
        },
        [surveyCompletedValidatorServer.fulfilled] : (state, action) => {
            console.log("action.payload for validator server", action.payload.Result)
            if((action.payload.Result).toString() == 'Survey Already Submitted'){
                // window.alert(action.payload.Result)
                state.message = action.payload.Result
                state.messageCondition = true
                state.messageType = 'error'
            }
            state.isLoading = false
        },
        [surveyCompletedValidatorServer.rejected] : (state, action) => {

        }
    }
})

export const {setAnswerBoolState, setTeamId, setPersonId, setSuccessMessage, setErrorMessage, setMessageToFalse} = surveyQuestionSlice.actions
export default surveyQuestionSlice.reducer